import { FC, Suspense } from 'react'
import { Route, Routes, Navigate } from 'react-router-dom'
import { MasterLayout } from '../../_metronic/layout/MasterLayout'
import TopBarProgress from 'react-topbar-progress-indicator'
import { DashboardPage } from '../pages/dashboard/DashboardPage'
import { getCSSVariableValue } from '../../_metronic/assets/ts/_utils'
import { WithChildren } from '../../_metronic/helpers'
import { useAuth } from '../modules/auth'
import { AdministracaoPage } from '../pages/administracao/AdministracaoPage'
import { EnumAutenticacaoTipo } from '../modules/services/core/_enums'
import ContaPage from '../pages/conta/ContaPage'
import MenuTestPage from '../pages/MenuTestPage'
import MapGateway from '../pages/MapGateway'
import MapAtivo from '../pages/MapAtivo'
import MenuGateway from '../pages/MenuGateway'
import MenuGatewayMapa from '../pages/MenuGatewayMapa'
import MenuAtivoMapa from '../pages/MenuAtivoMapa'
import MenuVisaoGeral from '../pages/MenuVisaoGeral'
import MenuAlertTestPage from '../pages/MenuAlertTestPage'
import MenuGatewayDetail from '../pages/MenuGatewayDetail'
import MenuAtivoDetail from '../pages/MenuAtivoDetail'
import MenuChamadoGateway from '../pages/MenuChamadoGateway'
import MenuChamadoAtivo from '../pages/MenuChamadoAtivo'
import NovoChamado from '../pages/NovoChamadoGateway'
import NovoChamadoGateway from '../pages/NovoChamadoGateway'
import MovimentacaoDeAtivos from '../pages/MenuAtivoMovimentação'
import NovoChamadoAtivo from '../pages/NovoChamadoAtivo'
import MenuAddAlertAtivo from '../pages/MenuAddAlertAtivo'
import MenuAddAlertGateway from '../pages/MenuAddAlertGateway'
import MenuEscalarAlertasAtivos from '../pages/MenuEscalarAlertaAtivo'
import MenuEscalarAlertasGateway from '../pages/MenuEscalarAlertaGateway'
import LocaisMapPage from '../pages/MapLocais'
import MenuMqtt from '../pages/MenuMqtt'
import Consolidado from '../pages/consolidado'
import MenuAtivosCampos from '../pages/MenuAtivosCampos'
import { AccessControl } from '../../components/AccessControl'

const PrivateRoutes = () => {
  const { auth } = useAuth()

  return (
    <AccessControl>
      <Routes>
        <Route element={<MasterLayout />}>
          <Route path='test' element={<MenuTestPage />} />
          <Route path='mapgateway' element={<MapGateway />} />
          <Route path='maplocal' element={<LocaisMapPage />} />
          <Route path='mapativo' element={<MapAtivo />} />
          <Route path='gateway' element={<MenuGateway />} />
          <Route path='alert' element={<MenuAlertTestPage />} />
          <Route path='chamado-gateway' element={<MenuChamadoGateway />} />
          <Route path='movimentacaodeativos' element={<MovimentacaoDeAtivos />} />
          <Route path='chamado-ativo' element={<MenuChamadoAtivo />} />
          <Route path='dashboard' element={<DashboardPage />} />
          <Route path='criar-alerta-gateway' element={<MenuAddAlertGateway />} />
          <Route path='criar-alerta-ativo' element={<MenuAddAlertAtivo />} />
          <Route path='escalar-alerta-ativo' element={<MenuEscalarAlertasAtivos />} />
          <Route path='escalar-alerta-gateway' element={<MenuEscalarAlertasGateway />} />
          <Route path='ativos-mapa' element={<MenuAtivoMapa />} />
          <Route path='ativos-campos' element={<MenuAtivosCampos />} />
          <Route path='visao-geral' element={<MenuVisaoGeral />} />
          <Route path='Mqtt' element={<MenuMqtt />} />
          <Route path='gateway-mapa' element={<MenuGatewayMapa />} />
          <Route path='detalhes-do-gateway' element={<MenuGatewayDetail />} />
          <Route path='detalhes-do-ativo' element={<MenuAtivoDetail />} />
          <Route path='novo-chamado' element={<NovoChamado />} />
          <Route path='novo-chamado-gateway' element={<NovoChamadoGateway />} />
          <Route path='novo-chamado-ativo' element={<NovoChamadoAtivo />} />
          <Route path='consolidado' element={<Consolidado />} />
          {auth && auth.Tipo === EnumAutenticacaoTipo.AspNetID && (
            <Route path='conta/*' element={<ContaPage />} />
          )}
          <Route
            path='administracao/*'
            element={
              <SuspensedView>
                <AdministracaoPage />
              </SuspensedView>
            }
          />
          <Route index element={<Navigate to='/dashboard' />} />
          <Route path='*' element={<Navigate to='/dashboard' />} />
        </Route>
      </Routes>
    </AccessControl>
  )
}

const SuspensedView: FC<WithChildren> = ({ children }) => {
  const baseColor = getCSSVariableValue('--bs-primary')
  TopBarProgress.config({
    barColors: {
      '0': baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  })
  return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>
}

export { PrivateRoutes }
